var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPbfRegisteredToAnotherPbfPayee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "#FF2800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.496 11.15c-2.475 0-4.138-1.85-4.138-4.313 0-2.462 1.663-4.312 4.138-4.312 2.462 0 4.137 1.85 4.137 4.313 0 2.462-1.675 4.312-4.137 4.312zm0-.925c1.862 0 3.062-1.45 3.062-3.387 0-1.95-1.2-3.388-3.062-3.388-1.875 0-3.063 1.438-3.063 3.388 0 1.937 1.188 3.387 3.063 3.387z",
    fill: "#fff"
  })));
}
export default SvgPbfRegisteredToAnotherPbfPayee;